module EEX.McEc.Commands {

    export class CreatePrivateKeyCommand {

        public createPrivateKey(success: (store: Pki.Store) => void): void {
            var store = new Pki.Store();
            store.createPrivateAndPublicKeyPair(
                () => {
                    success(store);
                }
            );
        }
    }
}
